<ng-container *ngIf="resource$ | async as resource">
  <h1 i18n="@@resourceEdit-heading-resourceEdit">Resource edit</h1>

  <rl-resource-edit
    [resource]="resource"
    (backButtonClicked)="back()"
    (updateBibliographicResource)="updateBibliographicResource($event)"
  ></rl-resource-edit>
</ng-container>
